import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const GROUPS = [["patients", "Patients"], ["appointments", "Appointments"], ["prescriptions", "Prescriptions"], ["bills", "Bills"], ["users", "Users"]];

export default function RecycleBin() {
const [data, setData] = useState({
    patients: [],
    appointments: [],
    prescriptions: [],
    bills: [],
    users: []
});  const load = () => api.get("/recycle-bin").then(({ data }) => setData(data));
  useEffect(() => { load(); }, []);

  const restore = async (entity, id) => {
    try { await api.post(`/recycle-bin/restore?entity=${entity}&entity_id=${id}`); toast.success("Record restored"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
const restoreAll = async () => {
  try {
    await api.post("/recycle-bin/restore-all");
    toast.success("All records restored successfully");
    load();
  } catch (e) {
    toast.error(errMsg(e));
  }
};

const emptyRecycleBin = async () => {
  const ok = window.confirm(
    "Are you sure you want to permanently delete everything in the recycle bin?\n\nThis action cannot be undone."
  );

  if (!ok) return;

  try {
    await api.delete("/recycle-bin/empty");
    toast.success("Recycle Bin emptied successfully");
    load();
  } catch (e) {
    toast.error(errMsg(e));
  }
};
  return (
    <div className="space-y-5" data-testid="recycle-bin-page">
      <div>
        <p className="text-xs font-mono uppercase tracking-widest text-primary">Admin only</p>
        <h1 className="font-heading text-3xl font-bold tracking-tight">Recycle bin</h1>
      </div>
      <Tabs defaultValue="patients">
        <TabsList>
          {GROUPS.map(([k, label]) => (
            <TabsTrigger key={k} value={k} data-testid={`recycle-tab-${k}`}>
              {label} ({data[k].length})
            </TabsTrigger>
          ))}
        </TabsList>
        {GROUPS.map(([k, label]) => (
          <TabsContent key={k} value={k}>
            <Card className="shadow-sm">
              <CardContent className="p-0">
                <div className="flex justify-end gap-2 mb-4">
  <Button
    variant="outline"
    onClick={() => restoreAll()}
  >
    Restore All
  </Button>

  <Button
    variant="destructive"
    onClick={() => emptyRecycleBin()}
  >
    Empty Recycle Bin
  </Button>
</div>
                <Table>
                  <TableHeader><TableRow>
                    <TableHead>ID</TableHead><TableHead>Reference</TableHead><TableHead className="text-right">Action</TableHead>
                  </TableRow></TableHeader>
                  <TableBody>
                    {data[k].length === 0 && (
                      <TableRow><TableCell colSpan={3} className="text-center py-8 text-sm text-muted-foreground">
                        No deleted {label.toLowerCase()}.
                      </TableCell></TableRow>
                    )}
                    {data[k].map((r) => (
                      <TableRow key={r.id}>
                        <TableCell className="font-mono text-xs">#{r.id}</TableCell>
                        <TableCell>{r.name || r.full_name || r.number || r.uhid || "—"}</TableCell>
                        <TableCell className="text-right">
                          <Button size="sm" variant="outline" data-testid={`restore-${k}-${r.id}`}
                            onClick={() => restore(k, r.id)}>Restore</Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </CardContent>
            </Card>
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
